import DowntimeReasonsHelpMdx from "../../help/downtime-reasons.mdx";

export function DowntimeReasonsHelpPage() {
  return <DowntimeReasonsHelpMdx />;
}
